<script lang="ts">
  let { text, variant = 'brand' }: { text: string; variant?: 'neutral' | 'brand' | 'warning' | 'success' } = $props()
</script>

<li
  class={['tag-pill', {
    '-variant-neutral': variant === 'neutral',
    '-variant-brand': variant === 'brand',
    '-variant-warning': variant === 'warning',
    '-variant-success': variant === 'success',
  }]}
>
  {text}
</li>

<style>
  .tag-pill {
    font-size: var(--font-size-2);
    font-weight: var(--font-weight-3);
    padding: var(--space-1) var(--space-2);
    border-radius: var(--radius-1);
  }

  .tag-pill.-variant-neutral {
    background-color: var(--color-variant-neutral-muted);
    color: var(--color-variant-neutral);
  }

  .tag-pill.-variant-brand {
    background-color: var(--color-variant-brand-muted);
    color: var(--color-variant-brand);
  }

  .tag-pill.-variant-warning {
    background-color: var(--color-variant-warning-muted);
    color: var(--color-variant-warning);
  }

  .tag-pill.-variant-success {
    background-color: var(--color-variant-success-muted);
    color: var(--color-variant-success);
  }
</style>
